export const API_URL = process.env.REACT_APP_API_URL ?? '';
export const AUTH_URL = process.env.REACT_APP_AUTH_URL ?? '';
export const TOKEN_URL = process.env.REACT_APP_TOKEN_URL ?? '';
export const SSO_URL = process.env.REACT_APP_SSO_URL ?? '';
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID ?? '';
export const CLIENT_ID_TEST = process.env.REACT_APP_CLIENT_ID_TEST ?? '';
export const REDIRECT_URL =
  process.env.REACT_APP_REDIRECT_URL ?? window.location.origin;
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL ?? '';
export const FAQ_URL = process.env.REACT_APP_FAQ_URL ?? '';
export const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL ?? '';
export const SUPPORT_URL = process.env.REACT_APP_SUPPORT_URL ?? '';
export const CONTRIBUTE_TO_SDK_URL =
  process.env.REACT_APP_CONTRIBUTE_TO_SDK_URL ?? '';
export const CARD_CREATION_URL = process.env.REACT_APP_CARD_CREATION_URL ?? '';
export const APP_DEFAULT_MODE = process.env.REACT_APP_DEFAULT_MODE ?? 'live';
